import axios from "axios"
import * as toastr from "toastr"
import "toastr/build/toastr.min.css"
import { errorToastr } from '../services/error-handler'

toastr.options.timeOut = 5000
toastr.options.positionClass = "toast-bottom-center"
toastr.options.toastClass = "toast1-class"

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // jwt error handling
    // return Promise.reject(error);
    console.log(error, "sdfdf")
    return Promise.reject(error);

  }
)
